import { IPodsLocation } from '@northladder/services';

import { IPodsLocationResponse } from '../../../types';

/**
 * Formats the available POD locations response by mapping
 * the raw response data to a new structure.
 *
 * @param raw - An array of raw POD location response objects to be formatted.
 * @returns An array of formatted POD location response objects with the
 * formatted property.
 */
export function formatAvailablePodLocationsResponse(
  raw: IPodsLocationResponse[]
): IPodsLocation[] {
  return raw.map((location) => ({
    ...location,
    id: location._id,
  }));
}
